module.exports = __webpack_public_path__ + "img/satin.be5030ca.webp";